﻿import React, { FC, PropsWithChildren } from 'react';
import styles from './ExpandedRowSections.module.scss';
import clsx from 'clsx';

type ExpandedRowSectionsProps = PropsWithChildren;

type ExpandedRowSectionsColumnsProps = PropsWithChildren & { colored?: boolean; className?: string };

type ExpandedRowSectionProps = PropsWithChildren;

const ExpandedRowSections: FC<ExpandedRowSectionsProps> & {
  Column: FC<ExpandedRowSectionsColumnsProps>;
  Section: FC<ExpandedRowSectionProps>;
} = (props) => {
  return <div className={styles.sections}>{props.children}</div>;
};

ExpandedRowSections.Column = (props) => (
  <div className={clsx(styles.sectionsColumn, props.className, { [styles.colored]: props.colored })}>
    {props.children}
  </div>
);

ExpandedRowSections.Section = (props) => <div className={styles.section}>{props.children}</div>;
export default ExpandedRowSections;
